import React from "react";
import { CheckCircle, Droplets, Battery, Circle, Wrench } from "lucide-react";
import { wasteSolutions } from "@/data/metiers/garagisteData";

const iconMap = {
  Droplets,
  Battery,
  Circle,
  Wrench
};

const GaragisteSolutions = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6 text-fabre-gray">
              Nos solutions pour chaque type de déchet
            </h2>
            <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-8 rounded-full"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des solutions spécialisées et conformes pour tous les déchets générés par votre activité automobile
            </p>
          </div>

          <div className="space-y-12">
            {wasteSolutions.map((solution, index) => {
              const IconComponent = iconMap[solution.icon as keyof typeof iconMap];
              
              return (
                <div key={index} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
                  <div className="grid grid-cols-1 lg:grid-cols-2">
                    <div className="p-8 lg:p-12">
                      <div className="flex items-center mb-6">
                        <div className="bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 p-4 rounded-2xl mr-4">
                          <IconComponent className="h-8 w-8 text-fabre-green" />
                        </div>
                        <h3 className="text-2xl font-heading font-bold text-fabre-gray">
                          {solution.title}
                        </h3>
                      </div>
                      
                      <p className="text-gray-700 text-lg leading-relaxed mb-6">
                        {solution.description}
                      </p>

                      <div className="mb-6">
                        <h4 className="text-lg font-bold text-fabre-gray mb-3">Nos services :</h4>
                        <ul className="space-y-2">
                          {solution.solutions.map((item, idx) => (
                            <li key={idx} className="flex items-center">
                              <CheckCircle className="h-5 w-5 text-fabre-green mr-3 flex-shrink-0" />
                              <span className="text-gray-700">{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-gradient-to-br from-fabre-lightgreen to-white p-4 rounded-xl">
                          <h5 className="font-bold text-fabre-gray mb-2">Impact environnemental</h5>
                          <p className="text-sm text-gray-700">{solution.benefit}</p>
                        </div>
                        <div className="bg-gradient-to-br from-fabre-lightgray to-white p-4 rounded-xl">
                          <h5 className="font-bold text-fabre-gray mb-2">Conformité</h5>
                          <p className="text-sm text-gray-700">{solution.regulation}</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-br from-fabre-lightgray to-white p-8 lg:p-12 flex items-center justify-center">
                      <div className="text-center">
                        <IconComponent className="h-24 w-24 text-fabre-green mx-auto mb-4 opacity-20" />
                        <div className="bg-white rounded-2xl p-6 shadow-lg">
                          <div className="text-3xl font-bold text-fabre-green mb-2">
                            {index === 0 ? "100%" : index === 1 ? "99%" : index === 2 ? "95%" : "90%"}
                          </div>
                          <div className="text-gray-600">Taux de valorisation</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GaragisteSolutions;